import {
  SET_CLIENT_INFO,
  SET_DEANINOMIZE,
  SET_DEPARTMENTS,
  SET_OPERATORS,
  SET_RECENT_CALLS,
  SET_TRANSFER_FAIL,
  TOGGLE_DEPARTMENTS,
  TOGGLE_OPERATORS,
  TOGGLE_RECENT_CALLS,
  TOGGLE_SHOWING,
  VOX_ANSWER,
  VOX_BAN,
  VOX_CALL_DISCONNECTED,
  VOX_CALL_INCOMING,
  VOX_CALL_OUTGOING,
  VOX_CONNECTED,
  VOX_CONNECTION_ESTABLISHED,
  VOX_CONNECTION_FAILED,
  VOX_AUTH_SUCCESS,
  VOX_AUTH_FAILED,
  VOX_CONNECTION_CLOSED,
  VOX_HOLD,
  VOX_MUTE,
  VOX_INIT,
  VOX_REQUESTING_HELP,
  SET_VOX_STATUS,
  VOX_SET_PBX_ID,
  VOX_SET_CALL_ID,
  VOX_SUPERVISING,
  VOX_SYNC_SOCKET_STATE,
  VOX_TRANSFER,
  VOX_UNBANNING,
  VOX_VOTE_NEED,
  VOX_WITHDRAW,
  VOX_SYNC_LAST_STATE,
  VOX_DESTROY,
  VOX_SHOW_ERROR,
  VOX_RESET_ERROR,
  VOX_INCIDENT,
} from '../../consts/vox';
import { VOX_ERRORS } from '../../consts/errors';

import { VOX_STATES } from '@constants/vox';

const initialState = {
  isShown: false,
  isConnected: false,
  isAuthorized: false,
  operator: null,
  contact: null,
  pbxId: null,
  state: VOX_STATES.OFFLINE,
  manualState: VOX_STATES.OFFLINE,
  operatorState: VOX_STATES.OFFLINE,
  calls: null,
  departments: null,
  operators: null,
  isIncoming: false,
  isAnswered: false,
  isHold: false,
  isMuted: false,
  isInterception: false,
  isSupervisor: null,
  isTransfering: false,
  isSupervising: false,
  isDeanonymised: false,
  isRequestingHelp: false,
  isVoteNeed: false,
  callIncomingTime: null,
  operatorsListOpened: false,
  forceUnban: false,
  isUnbanning: false,
  isMaster: false,
  error: null,
  serverError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SHOWING:
      return { ...state, isShown: action.isShown };

    case VOX_INIT:
      return {
        ...state,
        isMaster: true,
      };

    case VOX_CONNECTED:
      return {
        ...state,
        operator: action.operator,
        isSupervisor: action.isSupervisor,
      };

    case VOX_CONNECTION_ESTABLISHED:
      return {
        ...state,
        isConnected: true,
        error: null,
      };

    case VOX_CONNECTION_CLOSED:
    case VOX_CONNECTION_FAILED:
      return {
        ...state,
        operatorState: VOX_STATES.OFFLINE,
        isConnected: false,
        error: VOX_ERRORS.NETWORK,
      };

    case VOX_AUTH_SUCCESS:
      return {
        ...state,
        isAuthorized: true,
        error: null,
      };

    case VOX_AUTH_FAILED:
      return {
        ...state,
        isAuthorized: false,
        error: VOX_ERRORS.AUTH,
      };

    case SET_VOX_STATUS: {
      const nextState = action.isManual
        ? {
            operatorState: action.operatorState,
            manualState: action.operatorState,
          }
        : {
            operatorState: action.operatorState,
          };
      return { ...state, ...nextState };
    }

    case VOX_SYNC_SOCKET_STATE: {
      return {
        ...state,
        state: action.state,
        operatorState: action.operatorState,
      };
    }

    case VOX_SET_PBX_ID:
      return { ...state, pbxId: String(action.pbxID) };

    case VOX_SET_CALL_ID:
      return { ...state, callId: String(action.callID) };

    case VOX_CALL_OUTGOING:
      return {
        ...state,
        state: VOX_STATES.OUTGOING,
        contact: {
          number: action.number,
        },
        isIncoming: false,
        operatorsListOpened: false,
      };

    case VOX_CALL_INCOMING:
      return {
        ...state,
        state: VOX_STATES.INCOMING,
        contact: {
          number: action.number,
          fullName: action.clientName || null,
        },
        callIncomingTime: performance.now(),
        forceUnban: false,
        isAnswered: false,
        isDeanonymised: action.isDeanonymised,
        isIncoming: true,
        isInterception: action.isInterception,
        pbxId: action.pbxId,
        operatorsListOpened: false,
      };

    case VOX_ANSWER:
      return { ...state, isAnswered: true };

    case VOX_CALL_DISCONNECTED:
      return {
        ...state,
        contact: {},
        isHold: false,
        isAnswered: false,
        isInterception: false,
        isTransfering: false,
        isDeanonymised: false,
        isSupervising: false,
        isRequestingHelp: false,
        isVoteNeed: false,
        callIncomingTime: null,
        forceUnban: action.forceUnban,
        isUnbanning: false,
        serverError: null,
      };

    case VOX_TRANSFER:
      return { ...state, isTransfering: true };

    case VOX_WITHDRAW:
      return { ...state, isInterception: false };

    case SET_TRANSFER_FAIL:
      return { ...state, isTransfering: false };

    case SET_OPERATORS:
      return { ...state, operators: action.operators };

    case SET_DEPARTMENTS:
      return { ...state, departments: action.departments };

    case SET_RECENT_CALLS:
      return { ...state, calls: action.calls };

    case SET_CLIENT_INFO:
      return { ...state, contact: action.contact };

    case VOX_HOLD:
      return { ...state, isHold: action.isHold };

    case VOX_MUTE:
      return { ...state, isMuted: action.isMuted };

    case VOX_VOTE_NEED:
      return { ...state, isVoteNeed: action.isVoteNeed };

    case SET_DEANINOMIZE:
      return { ...state, isDeanonymised: action.isDeanonymised };

    case VOX_SUPERVISING:
      return { ...state, isSupervising: action.isSupervising };

    case VOX_REQUESTING_HELP:
      return { ...state, isRequestingHelp: action.isRequestingHelp };

    case TOGGLE_RECENT_CALLS:
      return {
        ...state,
        calls: null,
      };

    case TOGGLE_OPERATORS:
      return {
        ...state,
        operators: null,
        operatorsListOpened: action.isOpen,
      };

    case TOGGLE_DEPARTMENTS:
      return {
        ...state,
        departments: null,
      };

    case VOX_BAN:
      return { ...state, state: VOX_STATES.BANNED };

    case VOX_UNBANNING:
      return { ...state, isUnbanning: action.isUnbanning };

    case VOX_SYNC_LAST_STATE:
      return {
        ...state,
        ...action.dialer,
      };

    case VOX_DESTROY:
      return {
        ...state,
        isMaster: false,
      };

    case VOX_SHOW_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case VOX_RESET_ERROR:
      return {
        ...state,
        error: null,
      };

    case VOX_INCIDENT:
      return {
        ...state,
        serverError: true,
      };

    default:
      return state;
  }
};
